import Notification from "../../components/Notification";
import {useSelector} from "react-redux";
import {FaceCool} from "@carbon/icons-react";
import {Heading} from "@carbon/react";
import {useMemo} from "react";
import {selectNotifications} from "../../features/application/applicationSlice";

const Index = () => {
    const notifications = useSelector(selectNotifications)
    
    const notificationItems = useMemo(() => 
        notifications.map((notification) => (
            <div key={notification.id} className="notification-item">
                <Notification notification={notification} persistent={true} />
            </div>
        )), [notifications]
    );
    
    return (
        <div className="page-container">
            <Heading className="notifications-heading">Notificaciones</Heading>
            <div className="notifications-grid">
                {notificationItems}
            </div>
            {notifications.length === 0 &&
                <div className="no-notifications">
                    <h2>Ninguna novedad</h2>
                    <FaceCool size={32}/>
                </div>
            }
        </div>
    )


}

export default Index
